import FeedbackPage from '@/components/FeedbackPage'

export default function PersonalizedPlanPreviewPage() {
  return (
    <FeedbackPage
      emoji="✨"
      title="pages.onboarding.personalizedPlanPreview.title"
    />
  )
}
